

<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</head>




<div class="card" *ngIf="ShowCard===2">
  <div class="card-body">
<br>
    <div class="row">
      <p style="color: #6ab187;"><strong>EMPLOYEE SCREENING</strong></p>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/users.png"><a style="text-decoration: none;color:black" routerLink="/whitecollar"> <strong class="white">&nbsp; White-collar verification</strong></a></div>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/mechanic.png"><a style="text-decoration: none;color: black;"  routerLink="/bluecollar"><strong class="white"> Blue-collar verification</strong></a></div>
      <br><br>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/online-business.png"><a style="text-decoration: none;color: black;" routerLink="/gigworker"> &nbsp;<strong class="white"> Gig Worker verification</strong></a></div>
    </div>
    <br>
    
    <div class="row">
      
      <p style="color: #6ab187;"><strong>RISK & COMPLIANCE</strong></p>
      <div class="col-3"><img style="width: 30px;height: auto;" src="assets/risktopicon.png"><a style="text-decoration: none;color: black;" routerLink="/riskmanage"><strong class="white"> Risk Management</strong></a></div>
      <div class="col-3"><img style="width: 35px;height: auto;" src="assets/onboarding.png"><a style="text-decoration: none;color: black;" routerLink="/vendor"><strong class="white" > Vendor Onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/distributortopicon.png"><a style="text-decoration: none;color: black;" routerLink="/distribute"><strong class="white"> Distributor onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/duediligence.jpg"><a style="text-decoration: none;color: black;" routerLink="/duediligence"><strong class="white"> Due Diligence</strong> </a></div>
    </div>
    <br>
  
    <!--  -->
    <div class="row">
      
      <p style="color: #6ab187;"><strong> FINANCIAL INTELLIGENCE</strong></p>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/kycsolution.png"><a style="text-decoration: none;color: black;" routerLink="/kycsolution"><strong class="white"> KYC solutions</strong> </a></div>
    </div>
    <br>
  
  </div>
</div>


<div class="card" *ngIf="ShowCard===1">
  <div class="card-body">
<br>
<p style="color: #6ab187;font-weight: 600;"><strong>PRODUCT</strong></p>

    <div class="row">
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" (click)="ShowCard=3"><strong class="white"><img style="width: 4%;height: 100%;" src="assets/docverify.png"> Document Verification</strong> </a></div>
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" routerLink="/service"><strong class="white"><img style="width: 5%;height: 110%;" src="assets/docsignin.png"> Document SignIn</strong> </a></div>
  
    </div>
    <br>

    <div class="row">
       </div>
    <br>
    
  </div>
</div>


<!--  -->

<div class="card" *ngIf="ShowCard===3">
  <div class="card-body">
    <br>
<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/aadhartopicon.png"><a style="text-decoration: none;color: black;" routerLink="/aadhaar"> <strong class="white"> Aadhaar verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/pantopicon.png"><a style="text-decoration: none;color: black;"  routerLink="/pan"><strong class="white"> Pan verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/gsttopicon.jpg"><a style="text-decoration: none;color: black;" routerLink="/gst"><strong class="white"> Gst verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/drivinglicensetop.jpg"><a style="text-decoration: none;color: black;" routerLink="/driving"><strong class="white"> Driving verification</strong></a></div>
</div><br><br>

<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/passporttopicon.png"><a style="text-decoration: none;color: black;" routerLink="/passport"><strong class="white"> Passport verification</strong> </a></div>
  <div class="col"><img style="width: 58px;height: 44px;" src="assets/rcverify.png"><a style="text-decoration: none;color: black;" routerLink="/rcverify"><strong class="white"> RC verification</strong></a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/msmeverify.png"><a style="text-decoration: none;color: black;" routerLink="/msmeverify"><strong class="white"> MSME verification</strong> </a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/verification.png"><a style="text-decoration: none;color: black;" routerLink="/dinverify"><strong class="white"> DIN verification</strong></a></div>
</div>

<br><br>
<div class="row">
  <div class="col-3"><img style="width: 35px;height: 44px;border-radius: 20px;" src="assets/cinicon.png"><a style="text-decoration: none;color: black;" routerLink="/cinverify"><strong  class="white"> CIN verification</strong></a></div>
</div>
</div>
</div>

<br><br>



<div class="row">
    <div style="text-align: center;" class="col">
        
        <h2 data-aos="fade-up" data-aos-delay="300"  style="color:#6ab187;">CIN API</h2>
        <h4 data-aos="fade-up" data-aos-delay="300" style="color: #6ab187;">Find CIN Number API for Unlocking the Power of CIN API</h4>
        <p data-aos="fade-up" data-aos-delay="300">CIN, or Corporate Identification Number, is a unique identifier assigned to every company in India. It <br>serves as a key to unlock a treasure trove of information about a business entity. Facheck  "CIN Number <br>API" is a powerful tool that can retrieve CINs efficiently, enabling you to access a wide array of company details.</p>
        <br>

        <h4 data-aos="fade-up" data-aos-delay="300"  style="color: #6ab187;">Find CIN to Company Detail API for Seamless Access Company Information</h4>
        <p data-aos="fade-up" data-aos-delay="300" >Are you in need of comprehensive company information but are daunted by the prospect of sifting through <br>multiple data sources?  Facheck's " CIN to Company Detail API" is the solution you've been looking for. <br>With a simple API call, you can access a wealth of information related to a specific company, saving your time and effort.</p>
        <br>

        <h4 data-aos="fade-up" data-aos-delay="300"  style="color: #6ab187;">Find CIN Detail API for A Deep Dive into Corporate Data</h4>
        <p data-aos="fade-up" data-aos-delay="300"  >The "Find CIN Detail API" offered by Facheck is your gateway to in-depth corporate data. It provides access <br>to an extensive range of information, including a company's registration details, financial data, and more. <br>This API empowers businesses with the insights they need to make informed decisions.</p>
        <br>

        <h4 data-aos="fade-up" data-aos-delay="300" style="color: #6ab187;">Fetch CIN to Company Detail API for Streamlined Company Data Retrieval</h4>
        <p data-aos="fade-up" data-aos-delay="300">Facheck's "Fetch CIN to Company Detail API" is designed to simplify the process of obtaining company<br>information. This API allows you to fetch data seamlessly by using CINs as the search criterion.<br> It's a time-saving solution for businesses that require access to up-to-date company details.</p>
        <br>

        <h4 data-aos="fade-up" data-aos-delay="300" style="color: #6ab187;">CIN to Company Detail API is Your Gateway to Business Intelligence</h4>
        <p data-aos="fade-up" data-aos-delay="300">With the "CIN to Company Detail API" by API Seva, you can effortlessly access information related to a<br> company. Whether you're interested in its registered address, directors, or financial status, this API can <br>provide it all. It's a valuable resource for various business needs.</p>
       <br>
        
        <h4 data-aos="fade-up" data-aos-delay="300" style="color: #6ab187;">Find CIN Number to Company Information API for Connecting CINs to Valuable Insights</h4>
        <p data-aos="fade-up" data-aos-delay="300">The "Find CIN Number to Company Information API" from Faheck bridges the gap between CINs and comprehensive <br>company information. It offers a seamless way to retrieve data related to a specific company, making it a <br>must-have tool for businesses seeking valuable insights.</p>
        <br>
          
        <h4 data-aos="fade-up" data-aos-delay="300" style="color: #6ab187;">Fetch CIN to Company Detail API for Effortless Access Company Data</h4>
        <p data-aos="fade-up" data-aos-delay="300">Facheck "Fetch CIN to Company Detail API" is the go-to solution for companies looking to access detailed<br> information effortlessly. This API ensures that you have all the necessary information at your fingertips,<br> allowing you to make well-informed decisions.</p>
        <br>  

        <h4 data-aos="fade-up" data-aos-delay="300" style="color: #6ab187;">
            Find CIN To MCA Detail API for Exploring the MCA Universe
            </h4>
        <p data-aos="fade-up" data-aos-delay="300"  >The Ministry of Corporate Affairs (MCA) plays a crucial role in regulating corporate affairs in India.<br> Facheck "CIN To MCA Detail API" offers access to MCA-related information, enabling businesses to stay compliant<br> and informed. This API is an invaluable resource for those navigating the complexities of Indian <br>corporate regulations.</p>
        <br>

        <h4 data-aos="fade-up" data-aos-delay="300" style="color: #6ab187;">Facheck Best Solution for CIN Number to MCA Detail API</h4>
        <p data-aos="fade-up" data-aos-delay="300">In today's fast-paced business environment, accessing accurate and up-to-date company information is <br>essential for success. Facheck suite of CIN APIs, including the "CIN Number API,"  provides businesses with <br>the tools they need to gain a competitive edge. By partnering with Facheck’s, you can harness the power of <br>these APIs and streamline your access to vital data. Ensure you make informed decisions and stay ahead in <br>the ever-evolving corporate landscape with API Seva's cutting-edge solutions.</p>
        <p data-aos="fade-up" data-aos-delay="300">Unlock the potential of CIN APIs and embrace the future of business intelligence with Facheck. Connect with <br>us today to explore our range of API solutions and transform the way you access company information.</p>
    </div>
</div>


 





